
// =============================== 获取隐藏标签================
//   获取token节点
//   let the_token=$("#scriptClass").attr("data-token");
  var fileref;
  fileref = document.createElement('link');
  fileref.setAttribute("rel", "stylesheet");
  fileref.setAttribute("type", "text/css");
  fileref.setAttribute("href", "https://www.omnipersonalizer.com/pages/info.css?shop="+window.location.host);
  document.getElementsByTagName("head")[0].appendChild(fileref);
  
//document.write('<link rel="stylesheet" href="info.css">')
/*获取文字*/
var languages = {}
$.ajax({
  type: "get",
  url: "https://www.omnipersonalizer.com/manage/language/getByLanguage?language=en_US",
  async: false,
  success: function(response) {
    languages = response
  }
});
    
 // ================================ 折扣后的数据 ================================================
   let afterDiscount = {
	"cartOrderVariantVos": [],
	"customerIdShop": 0,
  "totalDiscount": "",
  "properties": {}
  }
    // cart 获取
  let getCartInfo = []
  let getCustomInfo = []
   // =================================== 购物车接口 ==========================
    $.ajax({  
    type : "get",  
    url : "https://"+window.location.host+"/cart.js",  
    dataType:"text",
    async : false,
    success : function(data){  
      let total =  JSON.parse(data);
      console.log(total)
      getCustomInfo = total.items
      if(total.items) {
        total.items.map(items =>{
          getCartInfo.push({
            "currentPrice": null,
            "discountAmount": null,
            "finalPrice": items.final_price,
            "originalPrice": items.original_price,
            "quantity": items.quantity,
            "productIdShop": items.product_id,
            "variantIdShop": items.variant_id
          })
        })
      }
    },
    error: function(err){
      alert("error")
    }
  })
   
// =====================================自定义====================================
//         conALL=[];
//         getCustomInfo.map((tokes,index)=>{
//           $(".cart-drawer__content .cart-drawer__item").eq(index).find(".ajaxcart_url").remove();
//           if(!tokes.properties){return;}
//           if(tokes.properties.token){
//           	$.ajax({  
//             type : "get",  
//             url : "https://www.omnipersonalizer.com/personality/front/customerDesignOrder/getByToken?token="+tokes.properties.token,  
//             dataType:"text",
//             async : false,
//             success : function(suc){
//               let con='';
//           con+='<li class=" suf-pro product-details__item product-details__item--property" data-cart-item-property>';
//               JSON.parse(suc).map((surface,surindex)=>{
//                 con+='<div class="sufFather faceIconCart">'+
//                   ' <p class="suf" style="font-size:13px;"><span class="blod">+</span>'+surface.surfaceName+''+languages.customizationInfo+'</p>'+
//                    '</div>'; 
//                  con+='<div class="hide suf-pro faceProCart">'+
//                 '<div class="lookImg mt10 flex flex_center lookIconCart">'+
//                 '<img  style="width:50px;" src="https://www.omnipersonalizer.com'+surface.finalImage+'">'+
//                 '<span class="btnSpan" data-cart-item-property-value>'+languages.look+'</span>'+
//                   '</div>'+
//                 '<div class="model hide">'+
//                 '<div class="showPic3 pic3Icon"><img class="mt50" src="https://www.omnipersonalizer.com'+surface.finalImage +'" style="width:90%;"></a></div>'+
//               '</div>'+
//               '</div>'
//               });
//               con+='<li>';
//               conALL.push(con)
//               $(".ajaxcart_url").remove()
//               $(".cart tbody .cart__row").eq(index).find("a").each(function(){
//                 if($(this).text() == "Remove" ) {
//                 	$(this).before("<ul class='ajaxcart_url ajaxcart__product-meta' style='margin:0;list-style: none;padding:0;'>"+con+"</ul>");
//                 }
//               })
//             }
//           });
//         }
//       });
// ======================================= 折扣价格===================================================
  getCart()
  function getCart() {
     // 商品折扣后数据
    
    $.ajax({
      type: "post",
      url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/cartDiscount/getDiscount",
      data: JSON.stringify(getCartInfo),
      contentType: "application/json",
      dataType: "text",
      async: false,
      success: function(response) {
        afterDiscount.cartOrderVariantVos = [];
//         console.log(response)
        let variantDiscountVos = JSON.parse(response).variantDiscountVos;
        if(variantDiscountVos) {
          variantDiscountVos.map((getCon,i) =>{
            console.log("================单条价格cart=======================")
            $(".cart tbody tr").eq(i).children(".cart__price").html(`
               <div class="${getCon.discount ? 'hide' : ''}">${getCon.originalPrices}</div>
               <div class="${getCon.discount ? '' : 'hide'}">
               <s>${getCon.originalPrices}</s>
               <p class="order-discount" style="margin-bottom: 0px;">${getCon.currentPrice}</p>
               <p class="order-discount" style="font-size:12px;"> Discount：${getCon.discountAmount}</p>
               </div>
             `)
              console.log("================提示不满足=======================")	
          	  $(".cart tbody tr").eq(i).children(".cart__quantity-td span").remove()
              // ======================== 数量 ====================
              $(".cart tbody tr").eq(i).children(".cart__quantity-td").html(`
				<input  class="cart__qty-input cart__qty_agi" type="number"  id="${getCon.variantIdShop}" value="${getCon.quantity}" min="0" pattern="[0-9]*"  data-quantity-input-desktop="">
             `)
              
              console.log("================单条总价格=======================")
              $(".cart tbody tr").eq(i).children(".cart__final-price").html(`
              <div class="${getCon.discount ? 'hide' : ''}">${getCon.originalTotal}</div>
              <div class="${getCon.discount ? '' : 'hide'}">
              <s>${getCon.originalTotal}</s>
              <p class="order-discount">${getCon.total}</p>
              </div>
              `)
            let cartVos= {
              "quantity":getCon.quantity,
              "productShopId": getCon.productIdShop,
              "variantIdShop": getCon.variantIdShop,
              "properties":getCon.properties
            }
            afterDiscount.cartOrderVariantVos.push(cartVos)

          })
          console.log("================总价格=======================")
          $(".cart-subtotal__price").html(`${JSON.parse(response).totalCurrentPrice}`)
//           $(".cart__subtotal-wrapper").html(` <div style="width: 100%;"><h3 class="cart-drawer__subtotal" style="display: inline-block;float:left;">Subtotal</h3><span style="float:right;font-weight: bold;">${JSON.parse(response).totalCurrentPrice}</span></div>`)
          //================提交按钮=======================
          $("input[name='checkout']").addClass('hide')
          $(".controlsSubmitCart").remove()
          $("input[name='checkout']").before(`<div class="controlsSubmitCart" name="checkOut" style="
			display: inline-block;
            width: auto;
            text-decoration: none;
            text-align: center;
            vertical-align: middle;
            white-space: nowrap;
            cursor: pointer;
            border: 1px solid transparent;appearance: none;
            background-color: #006eff;
            color: #fff;font-size: 0.8125em;
            font-weight: 700;
            letter-spacing: 0.15em;
            text-transform: uppercase;
            padding: 15px 45px;
            transition: color 0.1s ease-in,background-color 0.1s ease-in;
		  ">Check out</div>`)

          //======s==========商品折扣后数据==============s=========
          afterDiscount.customerIdShop = ""
          if(__st.cid) {
            afterDiscount.customerIdShop = __st.cid
          } 
          afterDiscount.totalDiscount = JSON.parse(response).totalDiscount

        }
      },
      error: function(err) {
        console.log(err)
      }
    });
  
  }
	//更改数量
let sss = $(".cart-subtotal__price").text();
//   更改数量
$(document).on("blur",".cart__quantity-td input[type='number']",function() {
  let that= this,sGetVal = $(that).val();
  $(".cart tbody .cart__row").each(function(eq) {
    if($(this).find($("input[type='number']")).attr("id") == that.getAttribute("id")) {
      getCartInfo[eq].quantity = sGetVal
      getCart()
    }
   })
})
$('table').click(function() {
  if($(this).text() == "Remove" ) {
    setTimeout(function(){
    	location.reload()
    },500)
  }
});

  // 结算
  $(document).on("click",".controlsSubmitCart",function() {
//     console.log(JSON.stringify(afterDiscount))
    $.ajax({
        type: "post",
        url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/cartDiscount/addDraftOrder",
        data: JSON.stringify(afterDiscount),
        contentType: "application/json",
        dataType: "text",
        async: false,
        success: function(response) {
          if(JSON.parse(response).success) {
            window.location.href = JSON.parse(response).url
          } else {
            $(".cart__quantity-td span").remove()
            // 判断是否符合要求
            JSON.parse(response).orderResultVariantVos.map((getMinNum,minI) =>{
              console.log(getMinNum.moqCondition)
              if(getMinNum.variantIdShop == afterDiscount.cartOrderVariantVos[minI].variantIdShop) {
                if(!getMinNum.moqCondition){
                  console.log(minI)
                  $(".cart__row").eq(minI).find(".cart__qty-input").before(`<span style="font-size:;12px;color:red;display:block;">${getMinNum.message}</span>`)
                }
              }
            })
          }
//           console.log(response)
//           console.log(JSON.parse(response).success)
        },
        error: function(err) {
          console.log(err)
        }
      });
    
  });
// 展开
      $(document).on("click",".faceIconCart",function(){
        $(this).next(".faceProCart").toggleClass("hide")
          if($(this).children().children(".blod").text()=="+"){
            $(this).children().children(".blod").text("-")
          } else {
            $(this).children().children(".blod").text("+")
          }
      })
     //查看图片
    $(document).on("click",".lookIconCart",function(){
      if($(window).width()>800){
        $(".pic3Icon").css({"position":"fixed","top":$(window).scrollTop(),"left":0,"right":0,"margin":"0 auto","text-align":"center","max-width":"500px","padding":"20px 0"})
      } else{
      	$(".pic3Icon").css({"position":"fixed","top":"4%","left":0,"right":0,"margin":"0 auto","text-align":"center","max-width":"500px","padding":"20px 0"})
      }
      $(this).next(".model").removeClass("hide")
    })
    //隐藏图片
    $(document).on("click",".model",function(){
      $(this).addClass("hide")
    })

    